import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export const useGlobalQueryInvalidation = () => {
  const $ = _c(7);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = async () => {
      await Promise.all([queryClient.invalidateQueries({
        queryKey: ["surveys-infinite"],
        exact: false
      }), queryClient.invalidateQueries({
        queryKey: ["active-count"],
        exact: false
      }), queryClient.invalidateQueries({
        queryKey: ["closed-count"],
        exact: false
      })]);
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const invalidateAfterSurveyAction = t0;
  let t1;
  if ($[2] !== queryClient) {
    t1 = async surveyId => {
      await Promise.all([queryClient.invalidateQueries({
        queryKey: ["surveys-infinite"],
        exact: false
      }), queryClient.invalidateQueries({
        queryKey: ["survey"],
        exact: false,
        predicate: query => {
          const key = query.queryKey;
          return Array.isArray(key) && key[0] === "survey" && key.includes(surveyId);
        }
      }), queryClient.invalidateQueries({
        queryKey: ["active-count"],
        exact: false
      }), queryClient.invalidateQueries({
        queryKey: ["closed-count"],
        exact: false
      }), queryClient.invalidateQueries({
        queryKey: ["statuses"],
        exact: false
      })]);
    };
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const invalidateAfterSurveyStatusChange = t1;
  let t2;
  if ($[4] !== invalidateAfterSurveyAction || $[5] !== invalidateAfterSurveyStatusChange) {
    t2 = {
      invalidateAfterSurveyAction,
      invalidateAfterSurveyStatusChange
    };
    $[4] = invalidateAfterSurveyAction;
    $[5] = invalidateAfterSurveyStatusChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};